import {
  ImageContainer,
  LoginContent,
  LoginFormContainer,
  NewUserButton,
  NewUserContainer,
  NewUserContent,
  ForgotPasswordLink
} from './styles';

import { getImage } from '../../services/getAssets';
import { useAuth } from '../../hooks/useAuth';
import { LoginForm } from './LoginForm';
import { LoginMFA } from './LoginMFA';
import { TbUserPlus } from "react-icons/tb";
import MobileButtons from '../../components/mobile-buttons/mobileButtons';

export const Login = () => {
  const { step } = useAuth();

  return (
    <>
      <LoginContent>
        <LoginFormContainer>
          <ImageContainer>
            <img src={getImage('logo.png')} alt="" id='logo'/>
          </ImageContainer>

          {step === 1 ? (
            <>
              <LoginForm />

              <NewUserContainer>
                <NewUserContent>
                  <div>
                    <h3>Ainda não tem uma conta no {process.env.REACT_APP_COMPANY_NAME}?</h3>
                  </div>
                </NewUserContent>

                <div className='d-flex justify-content-between'>
                  <NewUserButton to="/cadastro" className={'col-md-4'}>
                    <TbUserPlus />
                    Abra sua conta
                  </NewUserButton>

                  <MobileButtons
                    googleButtonWidth="110"
                    googleButtonHeight="35"
                    appleButtonWidth="110"
                    appleButtonHeight="35"
                  />
                </div>

              </NewUserContainer>
            </>
          ) : <LoginMFA />}
        </LoginFormContainer>

        <img id = "image-login"src="/images/login-image.png" alt="" />
      </LoginContent>
    </>
  )
}
